import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Icon } from "./Icon";
import { DeskSpendTicker } from "./DeskSpendTicker";
import { deskScopedHref } from "../lib/deskTarget";

type NavItem = {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
  jobAware?: boolean;
};

const PRIMARY_NAV: NavItem[] = [
  { to: "/search", label: "Phase 1: Search", icon: "search", end: true },
  { to: "/evidence", label: "Phase 2: Evidence", icon: "account_tree", jobAware: true },
  { to: "/vendor-clusters", label: "Phase 3: Vendor Clusters", icon: "hub", jobAware: true },
  { to: "/projects", label: "Phase 4: Projects", icon: "folder_special" },
  { to: "/vendors", label: "Vendor admin", icon: "badge" },
  { to: "/eval-playground", label: "Eval playground", icon: "science" },
  { to: "/pdr-schema", label: "PDR schema", icon: "tune" },
];

const FOOTER_NAV: NavItem[] = [
  { to: "/budget", label: "Budget", icon: "account_balance_wallet" },
  { to: "/logs", label: "Execution logs", icon: "receipt_long" },
];

function SidebarLink({ item }: { item: NavItem }) {
  const to = item.jobAware ? deskScopedHref(item.to) : item.to;
  return (
    <NavLink
      key={item.to}
      to={to}
      end={item.end ?? false}
      className={({ isActive }) =>
        isActive
          ? "bg-surface-container-high text-primary font-bold border-l-2 border-primary px-4 py-3 flex items-center gap-3"
          : "text-on-surface-variant px-4 py-3 flex items-center gap-3 hover:bg-surface-variant transition-colors"
      }
    >
      <Icon name={item.icon} />
      <span className="font-data-label text-data-label uppercase">{item.label}</span>
    </NavLink>
  );
}

export function DeskSidebar() {
  const { user, authRequired, logout } = useAuth();

  return (
    <aside className="w-64 flex-shrink-0 border-r border-outline-variant bg-surface flex flex-col h-full">
      <div className="p-6">
        <h1 className="text-lg font-black text-primary tracking-tight">ORION-1</h1>
        <p className="text-[10px] uppercase tracking-widest text-on-surface-variant mt-1">
          Strategy Desk
        </p>
      </div>
      <nav className="flex-grow mt-2 flex flex-col min-h-0">
        <div className="flex flex-col">
          {PRIMARY_NAV.map((item) => (
            <SidebarLink key={item.to} item={item} />
          ))}
        </div>
        <div className="mt-auto border-t border-outline-variant flex flex-col">
          <DeskSpendTicker />
          {FOOTER_NAV.map((item) => (
            <SidebarLink key={item.to} item={item} />
          ))}
          {authRequired && user && (
            <div className="px-4 py-3 border-t border-outline-variant">
              <p className="text-xs text-on-surface truncate" title={user.email}>
                {user.display_name || user.email}
              </p>
              <button
                type="button"
                onClick={() => void logout()}
                className="mt-2 text-[10px] uppercase tracking-widest text-on-surface-variant hover:text-primary"
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </nav>
    </aside>
  );
}
